import { createFileRoute, Link } from "@tanstack/react-router";
import {
	ArrowLeft,
	ArrowRight,
	Calendar,
	Crown,
	FileText,
	UserCheck,
	Users,
} from "lucide-react";
import { useTranslation } from "react-i18next";

export const Route = createFileRoute("/_auth/app/_app/help/user-guide/")({
	component: RouteComponent,
});

function RouteComponent() {
	const { t } = useTranslation();

	const guideItems = [
		{
			key: "customerManagement",
			title: t("help.customerManagement"),
			description: t("help.customerManagementDescription"),
			icon: UserCheck,
			to: "/app/help/user-guide/customer-management",
			color: "text-purple-600",
			bgColor: "bg-purple-50",
		},
		{
			key: "staffManagement",
			title: t("help.staffManagement"),
			description: t("help.staffManagementDescription"),
			icon: Users,
			to: "/app/help/user-guide/staff-management",
			color: "text-green-600",
			bgColor: "bg-green-50",
		},

		{
			key: "customerPlans",
			title: t("help.customerPlans"),
			description: t("help.customerPlansDescription"),
			icon: Crown,
			to: "/app/help/user-guide/customer-plans",
			color: "text-yellow-600",
			bgColor: "bg-yellow-50",
		},
		{
			key: "scheduleManagement",
			title: t("help.scheduleManagement"),
			description: t("help.scheduleManagementDescription"),
			icon: Calendar,
			to: "/app/help/user-guide/schedule-management",
			color: "text-indigo-600",
			bgColor: "bg-indigo-50",
		},
		{
			key: "enrollmentProcess",
			title: t("help.enrollmentProcess"),
			description: t("help.enrollmentProcessDescription"),
			icon: FileText,
			to: "/app/help/user-guide/enrollment-process",
			color: "text-pink-600",
			bgColor: "bg-pink-50",
		},
		{
			key: "attendanceTracking",
			title: t("help.attendanceTracking"),
			description: t("help.attendanceTrackingDescription"),
			icon: UserCheck,
			to: "/app/help/user-guide/attendance-tracking",
			color: "text-teal-600",
			bgColor: "bg-teal-50",
		},
	];

	return (
		<div className="p-6 max-w-6xl mx-auto">
			{/* Mobile Back Button */}
			<Link
				to="/app/help"
				className="md:hidden flex items-center gap-2 text-primary mb-4"
			>
				<ArrowLeft className="w-4 h-4" />
				{t("common.back")}
			</Link>

			{/* Header */}
			<div className="mb-8">
				<h1 className="text-2xl sm:text-3xl font-bold text-base-content mb-2">
					{t("help.userGuideOverview")}
				</h1>
				<p className="text-base sm:text-lg text-base-content/70">
					{t("help.userGuideOverviewDescription")}
				</p>
			</div>

			{/* Guide Sections Grid */}
			<div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
				{guideItems.map((item) => {
					const Icon = item.icon;
					return (
						<Link
							key={item.key}
							to={item.to}
							className="group bg-base-100 p-6 rounded-lg border border-base-300 hover:shadow-lg hover:border-primary/20 transition-all duration-200"
						>
							<div
								className={`inline-flex p-3 rounded-lg ${item.bgColor} mb-4 group-hover:scale-110 transition-transform duration-200`}
							>
								<Icon className={`h-6 w-6 ${item.color}`} />
							</div>
							<h3 className="text-lg font-semibold text-base-content mb-2 group-hover:text-primary transition-colors">
								{item.title}
							</h3>
							<p className="text-base-content/70 text-sm mb-3">
								{item.description}
							</p>
							<div className="flex items-center text-primary text-sm font-medium group-hover:translate-x-1 transition-transform duration-200">
								{t("common.learnMore")}
								<ArrowRight className="h-4 w-4 ml-1" />
							</div>
						</Link>
					);
				})}
			</div>
		</div>
	);
}
